<template>
  <div class="huoti">
    <tip
      :show="tipDialogInfo.isShowTip"
      :titleText="tipDialogInfo.titleText"
      :isShowCancelBtn="tipDialogInfo.isShowCancelBtn"
      :cancelText="tipDialogInfo.cancelText"
      :confirmText="tipDialogInfo.confirmText"
      :isRemindAgain="tipDialogInfo.isRemindAgain"
      @cancel="onTipCancel"
      @confirm="onTipConfirm"
    >
      <div class="content-text" slot="content">
        <img
          v-if="tipDialogInfo.type == 'success'"
          class="icon-status"
          src="@/assets/img/img_success.png"
        />
        <img v-else class="icon-status" src="~@/assets/img/img_fail.png" />
        {{ tipDialogInfo.contentText }}
      </div>
    </tip>
  </div>
</template>
<script>
import { updatePhoneCheckLive } from '@/api/huoti'
import { redirectUrlHuoTiTencent } from '@/utils/redirect'
import wx from 'weixin-js-sdk'
import Tip from '@/views/components/tip.vue'
export default {
  components: {
    Tip
  },
  data() {
    return {
      tipDialogInfo: {
        isShowTip: false,
        type: '',
        titleText: '',
        cancelText: '回到首页',
        confirmText: '继续尝试',
        contentText: '',
        isShowCancelBtn: true
      }
    }
  },
  created() {
    console.log('this.$route.query', this.$route.query)
    if (!this.$route.query.code) {
      // 没code 去重定向 活体检测
      setTimeout(() => {
        redirectUrlHuoTiTencent(this.$route.query)
      }, 500)
    } else {
      // 有code 活体检测的回调，调用接口查看结果
      this.updatePhoneCheckLive()
    }
  },
  methods: {
    onTipCancel(res) {
      this.tipDialogInfo.isShowTip = false
      wx.miniProgram.switchTab({
        url: '/pages/tabBars/home'
      })
    },
    onTipConfirm(res) {
      this.tipDialogInfo.isShowTip = false
      if (this.tipDialogInfo.type == 'success') {
        wx.miniProgram.redirectTo({
          url: `/pagesLogin/pages/update-phone?orderNo=${this.$route.query.orderNo}`
        })
      }
      if (this.tipDialogInfo.type == 'retry') {
        console.log('4-重试')
        wx.miniProgram.navigateBack()
      }
    },
    updatePhoneCheckLive() {
      const params = {
        orderId: this.$route.query.orderNo,
        liveType: 2
      }
      updatePhoneCheckLive(params).then(res => {
        console.log(res)
        if (res.ret == '00') {
          //活体成功下一步
          this.tipDialogInfo.isShowTip = true
          this.tipDialogInfo.type = 'success'
          this.tipDialogInfo.isShowCancelBtn = false
          this.tipDialogInfo.confirmText = '确定'
          this.tipDialogInfo.contentText = res.msg
        } else {
          this.tipDialogInfo.isShowTip = true
          this.tipDialogInfo.type = 'retry'
          this.tipDialogInfo.isShowCancelBtn = true
          this.tipDialogInfo.cancelText = '回到首页'
          this.tipDialogInfo.confirmText = '继续尝试'
          this.tipDialogInfo.contentText = res.msg
        }
      })
    }
  }
}
</script>
